import {
  FileIcon_default
} from "./chunk-2ELTSFQX.mjs";
export {
  FileIcon_default as default
};
